import { BONUS_CAMPAIGN_TYPE } from '../../constants/enums';
import BonusPage from './BonusPage';

const SelectionsBonusPage = () => <BonusPage type={BONUS_CAMPAIGN_TYPE.NUM_OF_SELECTIONS} formType='selections' />;

export default SelectionsBonusPage;
